<template>
<div class="downLoadBar tg-download pos-r" v-show="showStatus && !isApp">
	<div class="download paddingr10" :class="isweixin?'weixin':''" v-if="!isClose" transition="fade">
		<a href="javascript:void(0)" class="text-light" :data-scp="closeScp">
			<div class="downloadClose text-center" @click="close()"><i class="icon-close frs-28"></i></div>
		</a>
		<div class="downloadLogo marginr10">
			<img src="//image1.51tiangou.com/tgou2/img2/index/logo_130@2x.png" alt="天狗网">
		</div>
		<div class="downloadText pos-r float-left frs-20 text-darker">
			<div class="frs-28">下载大商天狗网APP</div><div class="text-dark downloadText_bottom">优惠信息不再错过</div>
		</div>
		<div class="float-right downloadBtn marginr10 frs-26" v-if="isweixin">
			<a href="/tempActivity/2015/10/fittingScan.html" class="text-red" :data-scp="wxScp">微信关注</a>
		</div>
		<div class="float-right downloadBtn marginr10 text-red frs-26">
			<a href="/index/loadAndroid.html" class="text-red" :data-scp="dlScp">立即下载</a>
		</div>
	</div>
</div>
</template>

<script>
import maple from 'maple';
import $ from 'jquery';

export default {
	props: {
		dlScp: {
			type: String
			, default: 'dl.00'
		}
		, wxScp: {
			type: String
			, default: 'mysmzt.00'
		}
		, closeScp: {
			type: String
			, default: 'cal.00'
		}
		, flagKey: {
			type: String
			, default: 'downLoadBarClose'
		}
	},
	data: function(){
		return {
			isweixin: maple.device.weixin
			, showStatus: true
			, isClose: maple.localData( this.flagKey )
			, isApp: maple.cookie('hybrid') === 'true'
		}
	}
	, ready: function(){
		$('body').addClass('body-download');
		//$('#scrollToTop').addClass('scrollToTop-download');
	}
	, methods: {
		close: function(){
			this.$destroy(true);
			maple.localData('downLoadBarClose', true);
			$('body').removeClass('body-download');
			$('#scrollToTop').removeClass('scrollToTop-download');
		}
	}
	, events: {
		closeDownload: function(){
			this.close();
		}
	}
};
</script>

<style lang="scss">
.fade-transition {
	transition: all .3s ease;
	height: 1.8rem;
	/*overflow: hidden;*/
}
.fade-enter, .fade-leave {
	height: 0;
}
.bounce-transition {
	height: 1.8rem;
	overflow: hidden;
}
.bounce-enter {
	animation: bounce-in .3s;
}
.bounce-leave {
	animation: bounce-out .3s;
}
@keyframes bounce-in{
	0%{opacity:1;
		-webkit-transform:translateY(0)}
	100%{opacity:0;
		-webkit-transform:translateY(-2000px);height: 0;}
}
@keyframes bounce-out{
	0%{opacity:1;
		-moz-transform:translateY(0)}
	100%{opacity:0;
		-moz-transform:translateY(-20px);height: 0;}
}
.body-download{
	padding-bottom: 124px;
}
.tg-download{
	background-color: rgba(240, 240, 240, 1);
}
#scrollToTop.scrollToTop-download{
	bottom: 116px;
}
.download{
	height: 1.4666667rem;
	margin-left: 2.2rem;
	color: #16cc90;
	/*padding:.3rem 25px .3rem 10px;*/
	/*background: rgba(0,0,0,.65);*/
}
.download.weixin{
	/*padding:.3rem .1rem .3rem .1rem;*/
}

.download .downloadClose{
	position: absolute;
	bottom: 0;
	top: 0;
	left: 0.2466663rem;
	height: 0.37333333rem;
	width: 0.37333333rem;
	margin: auto;
	/*color: #fff;*/
	line-height: 1;
}
.download .downloadText{
	/*color: #fff;*/
	/*flex-shrink: 0;*/
	top: 50%;
	-webkit-transform: translateY(-50%);
	transform: translateY(-50%);
}
.download .downloadText strong{
	display:block;
	/*letter-spacing: .15rem;*/
}
.download .downloadBtn{
	/*color: #fff;*/
	display: inline-block;
	height: 0.8rem;
	width: 2.1333333rem;
	margin-top: .33333333rem;
	line-height: 0.8rem;
	border-radius: .4rem;
	border: 1px solid #ff4c48;
	/*background: #16cc90;*/
	text-align: center;
}
.download .downloadBtn a{
	/*color: #fff;*/
}
/*.download .downloadBtn.weixin{*/
	/*width: 1.6rem;*/
	/*height: .64rem;*/
	/*line-height: .64rem;*/
/*}*/
.download .downloadLogo{
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0.866666rem;
	height: 1.066667rem;
	width: 1.066667rem;
	margin: auto;
}
.download .downloadLogo img{
	/*width: 1.28rem;*/
	height: 1.066667rem;
	width: 1.066667rem;
}
</style>
